/**
 * SortableHeader Component
 * Reusable sortable table header cell with ascending/descending indicators.
 * Used across all data tables for consistent sort UX.
 */

import type { SortState } from '@/hooks/useTableSort';

interface SortableHeaderProps {
  label: string;
  sortKey: string;
  sortState: SortState | null;
  onToggle: (key: string) => void;
  alignRight?: boolean;
}

export function SortableHeader({
  label,
  sortKey,
  sortState,
  onToggle,
  alignRight,
}: SortableHeaderProps) {
  const isActive = sortState?.key === sortKey;
  const arrow = isActive
    ? sortState.direction === 'asc' ? '\u25B2' : '\u25BC'
    : '\u25B4';

  return (
    <th
      className="sortable-header"
      onClick={() => onToggle(sortKey)}
      style={alignRight ? { textAlign: 'right' } : undefined}
    >
      {label}
      <span className={`sort-indicator${isActive ? ' sort-indicator--active' : ''}`}>
        {arrow}
      </span>
    </th>
  );
}
